import type { ReactNode } from 'react';
import { CircleAlert, CircleCheck, Info, Lock } from 'lucide-react';
import { cx } from './cx';

export type BannerTone = 'info' | 'success' | 'warn' | 'error' | 'lock';
const styles: Record<BannerTone, string> = {
  info: 'bg-brand-soft text-brand',
  lock: 'bg-brand-soft text-brand',
  success: 'bg-ok-bg text-ok-fg',
  warn: 'border border-warn-line bg-warn-tint text-warn-fg',
  error: 'bg-bad-bg text-bad',
};

export function Banner({ tone = 'info', children, className, role }: { tone?: BannerTone; children: ReactNode; className?: string; role?: 'status' | 'alert' }) {
  const Icon = tone === 'success' ? CircleCheck : tone === 'lock' ? Lock : tone === 'info' ? Info : CircleAlert;
  return (
    <div role={role} className={cx('flex items-start gap-2.5 rounded-xl px-4 py-3 text-sm leading-[1.5]', styles[tone], className)}>
      <Icon aria-hidden="true" size={18} strokeWidth={2} className="mt-px flex-none" />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
